import React from "react";
import RightSideModel from "src/components/popup/rightSide/RightSideModel";
import IotCallingCampaignForm from "../form/IotCallingCampaignForm/IotCallingCampaignForm";

const titlePopup = (isEdit) => {
  return isEdit ? "Edit Iot Calling Campaign" : "Create Iot Calling Campaign";
};

const IotCallingPopupCampaign = ({
  recordForEdit,
  openPopup,
  setOpenPopup,
  addOrEdit,
  errorsForm,
}) => {
  return (
    <RightSideModel
      openPopup={openPopup}
      setOpenPopup={setOpenPopup}
      title={titlePopup(Boolean(recordForEdit))}
    >
      <IotCallingCampaignForm
        recordForEdit={recordForEdit}
        addOrEdit={addOrEdit}
        errorsForm={errorsForm}
      />
    </RightSideModel>
  );
};

export default IotCallingPopupCampaign;
